/**
 * Typ hodnoty uchovávané v typu Variant
 * @includeToDoc
 */
export enum VariantType {
    string = "string",
    number = "number",
}

/**
 * Datový typ reprezentující strukturu, která může uchovávat hodnotu různých datových typů. V současnosti reprezentuje aplikační typ StrNum a umí uchovávat hodnoty typu number a string.
 * @includeToDoc
 * @generateInstanceClass
*/
export interface IVariant {
    /** Typ uchovávané hodnoty */
    readonly type: VariantType;
    /** Uchovávaná hodnota */
    readonly value: any;
    /** Počet desetinných čísel pro formátování číselných hodnot */
    readonly decimalCount?: number;
}

export class IVariant {
    private static _properties: (keyof IVariant)[] = ["type", "value"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && typeof instance === "object" && !this._properties.some((value) => !Reflect.has(instance, value));
    }
}
